import { CheckCircleOutline, ShoppingCart  } from "@mui/icons-material";
import usePack from "../utils/usePack";

export default function Cart(){

   const { isSuccess, data } = usePack()

    return isSuccess &&

        <article className="apply-cart">

                <img
                    src={data.picture.url}
                    alt={data.title}
                    className="apply-cart-img"
                />

                <div className="apply-cart-content">

                
                    <span className="apply-cart-title">
                        {data.title}
                    </span>

                    <div className="apply-cart-info">

                        <CheckCircleOutline sx={iconSx} />

                        <span>2 formations en ligne, à suivre où et quand vous le souhaitez</span>

                    </div>

                    <div className="apply-cart-info">

                        <CheckCircleOutline sx={iconSx} />

                        <span>Accès à vie en illimité</span>

                        <span></span>

                    </div>

                    <div className="apply-cart-footer">

                        <ShoppingCart sx={iconSx} />

                        <span>TOTAL :</span>

                        <div className="apply-badge-dark" style={{ backgroundColor: data.category?.color}}>
                            
                            <span>
                                {data.price.toLocaleString()}€
                            </span>

                        </div>

                    </div>

                </div>

        </article>
}

export const iconSx = {
    fontSize: 22
}